import * as React from 'react';

import { TReduxStore } from '../../types/redux';

// oxlint-disable-next-line typescript/no-explicit-any
export const context = React.createContext<TReduxStore>(null as any);
context.displayName = 'FavoritesContext';
